import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDiscounts'
})
export class FilterDiscountsPipe implements PipeTransform {
  transform(value: any, before: boolean) {
    return (value || []).filter((x: any) => x.ApplyBeforeTax == before)
  }
}
